import { ChatbotConversation as e } from "./components/ChatbotConversation/ChatbotConversation.js";
import { EmbedIcon as n } from "./components/Embed/EmbedIcon.js";
import { AI_SUGGESTION_ID as C } from "./constants.js";
import { getCurrentChatSessionInfo as d, getEmbeddedChatbotState as m, setCurrentChatSessionInfo as b, setEmbeddedChatbotState as f } from "./utils/chat-session-storage.js";
import { shouldContinueConversation as I } from "./utils/should-continue-conversation.js";
export {
  C as AI_SUGGESTION_ID,
  e as Chatbot,
  n as EmbedIcon,
  d as getCurrentChatSessionInfo,
  m as getEmbeddedChatbotState,
  b as setCurrentChatSessionInfo,
  f as setEmbeddedChatbotState,
  I as shouldContinueConversation
};
